import { useState } from 'react'
import { useTranslation } from 'react-i18next'

import { Flex, Hide } from '@chakra-ui/react'

import { ReasonType } from '@wwt/entities/reason'
import ChangeIcon from '@wwt/shared/assets/icons/outline/change.svg'

import { useBreakpointValueWithoutSSR } from '@/shared/lib/hooks/useBreakpointValueWithoutSSR'

import { QuickActionButton } from './QuickActionButton'
import { QuickActionMiniSection } from './QuickActionMiniSection'
import { ReasonPopupHeader } from './ReasonPopupHeader'
import { SetChangePopup } from './SetChangePopup'

interface LikeContentProps {
	onOpenReview: () => void
	onOpenInfo: () => void
	onClose: () => void
	isFixed: boolean
	type: ReasonType
	offerId: string
}

const sets = {
	defaultSet: 'Cityscape Adventure',
	allSets: [
		'Buisness Travel Hub',
		'13 Jan',
		'Mountain Hideaway Haven',
		'24 May - 12 Jun',
		'Family Fun Gateway'
	]
}

export const LikeContent = ({
	onOpenReview,
	onOpenInfo,
	onClose,
	isFixed,
	type,
	offerId
}: LikeContentProps) => {
	const { t } = useTranslation('tooltips')
	const [isSetChangePopupOpen, setIsSetChangePopupOpen] = useState(false)

	const title = useBreakpointValueWithoutSSR({
		base: '',
		md: t('reasonPopup.roomIsAddedToSet', {
			setName: sets.defaultSet
		})
	})

	return (
		<Flex
			flexDirection={{ base: 'row', md: 'column' }}
			w="100%"
			alignItems={{ base: 'center', md: 'flex-start' }}
		>
			<ReasonPopupHeader
				isFixed={isFixed}
				headerText={title ?? ''}
				textStyle="body-text-5"
				onClose={onClose}
			/>
			<Hide below="md">
				<QuickActionButton
					text={t('reasonPopup.changeSet')}
					icon={ChangeIcon}
					pos="relative"
					onMouseOver={() => setIsSetChangePopupOpen(true)}
					onMouseLeave={() => setIsSetChangePopupOpen(false)}
				>
					<SetChangePopup
						sets={sets.allSets}
						isOpen={isSetChangePopupOpen}
						onMouseOver={() => setIsSetChangePopupOpen(true)}
						onMouseLeave={() => setIsSetChangePopupOpen(false)}
					/>
				</QuickActionButton>
			</Hide>
			<QuickActionMiniSection
				onInfoPopupOpen={onOpenInfo}
				onReviewPopupOpen={onOpenReview}
				type={type}
				offerId={offerId}
				onClose={onClose}
			/>
		</Flex>
	)
}
